import request from '@/utils/request'

// 获取地址列表
export function getAddressList(data) {
  return request({
    method: 'post',
    path: 'address/lists',
    data
  })
}

// 保存地址
export function saveAddress(data) {
  return request({
    method: 'post',
    path: 'address/save',
    data
  })
}


// 删除地址
export function deleteAddress(data) {
  return request({
    method: 'post',
    path: 'address/delete',
    data
  })
}


// 获取地址列表（所有）
export function getAllAddressList(data) {
  return request({
    method: 'post',
    path: 'address/all',
    data
  })
}
